import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts'

export interface TornadoGraphDataPoint {
  /** The range identifier/name */
  name: number
  /** Vault balance for this range */
  vaultBalance?: number
  /** Counter vault balance for this range */
  counterVaultBalance?: number
  /** Aggregate vault balance (positive side) */
  aggregateVaultBalance: number
  /** Aggregate counter vault balance (negative side) */
  aggregateCounterVaultBalance: number
}

export interface TriplePositionsTornadoMinGraphProps {
  /** Pre-formatted data for the tornado chart */
  data: TornadoGraphDataPoint[]
  /** Color for the "FOR" (vault) bars */
  forColor?: string
  /** Color for the "AGAINST" (counter vault) bars */
  againstColor?: string
  /** Additional className for the container */
  className?: string
}

/**
 * A minimal tornado/butterfly chart for displaying triple position distributions.
 * Shows FOR positions (green) on the right and AGAINST positions (red) on the left.
 * 
 * @example
 * <TriplePositionsTornadoMinGraph 
 *   data={formattedRanges} 
 *   forColor="#31ad31" 
 *   againstColor="#bc4535" 
 * />
 */
export const TriplePositionsTornadoMinGraph = ({
  data,
  forColor = '#31ad31',
  againstColor = '#bc4535',
  className,
}: TriplePositionsTornadoMinGraphProps) => {
  if (!data || data.length === 0) {
    return null
  }

  return (
    <ResponsiveContainer width="100%" height="100%" className={className}>
      <BarChart
        data={data}
        stackOffset="sign"
        layout="vertical"
        barGap={0}
        barCategoryGap={0}
      >
        <XAxis type="number" hide={true} />
        <YAxis dataKey="name" type="number" reversed hide={true} />
        <Bar dataKey="aggregateVaultBalance" fill={forColor} stackId="stack" />
        <Bar
          dataKey="aggregateCounterVaultBalance"
          fill={againstColor}
          stackId="stack"
        />
      </BarChart>
    </ResponsiveContainer>
  )
}

export default TriplePositionsTornadoMinGraph

